import ArrowLeftIcon from "assets/icons/HeroIcons/ArrowLeftIcon";
import CheveronRightIcon from "assets/icons/HeroIcons/CheveronRightIcon";
import ellipsize from "ellipsize";
import React from "react";
import { Link, useNavigate } from "react-router-dom";

interface LinkItem {
  path: string;
  label: string;
}

interface BreadcrumbProps {
  links: LinkItem[];
  handleClick?: () => void;
}

export const Breadcrumb: React.FC<BreadcrumbProps> = ({
  links,
  handleClick = null,
}) => {
  const navigate = useNavigate();

  return (
    <div className="flex items-center justify-start">
      {links.length > 0 && (
        <button
          onClick={() => {
            if (handleClick) {
              handleClick();
            } else {
              navigate(-1);
            }
          }}
          type="button"
          className="flex items-center mr-2 space-x-2 text-textMid hover:underline"
        >
          <ArrowLeftIcon height={22} width={22} />
        </button>
      )}
      {links.map((link, index) => (
        <React.Fragment key={index}>
          {index > 0 && <CheveronRightIcon height={22} width={22} />}
          {index === links.length - 1 ? (
            <span
              className="flex items-center space-x-2"
              style={{
                color: "#54595F",
                cursor: "default",
              }}
            >
              <p className="text-sm capitalize dark:text-textMain">
                {ellipsize(link.label, 100)}
              </p>
            </span>
          ) : (
            <Link
              to={link.path}
              className="flex items-center space-x-2 shrink-0 color-[#2C3236] hover:underline"
            >
              <p className="text-sm capitalize dark:text-textMain">
                {ellipsize(link.label, 100)}
              </p>
            </Link>
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default Breadcrumb;
